export default __webpack_public_path__ + "static/SONY_IMX335_Indoor_thumb-5ee885d0642558d3b65ce380140222b8.webp";